import LogoSlider from "../HomePage/LogoSlider";
import ContactUsBanner from "./ContactUsBanner";
import ContactUsTab from "./ContactUsTab";



function ContactUsPage() {
  return (
    <>
        <ContactUsBanner/>
        <ContactUsTab/>
        <section className="pt-0">
            <div className="container max-1330 mx-auto">
                <LogoSlider/>
            </div>
        </section>
        
    </>
  )
}

export default ContactUsPage;